import React, { useState, useEffect } from 'react';
import { CancelButton, Space, SubmitButton } from '../../../Res/BaseButton';
import { SingleText, SingleInput, SingleSelect } from '../../../Res/BaseInput';
import { RespActionList, pitch_type_arr, RespActionEditPitch } from '../../../../../item/MyStat/actionList';
import { api_setPlateRecordActionDetail, api_setPlateRecordActionDetailPitch } from '../../../../../api/MyStat/apiPlateRecord';
import moment from 'moment';

export function ActionEditPitch({ setIsLoading, mRespActionList, set_Save, set_Close }) {

    const [respActionList, setRespActionList] = useState(new RespActionList({}))
    const [pitch_type, set_pitch_type] = useState("")
    const [pitch_speed, set_pitch_speed] = useState("")
    const [video_timestamp, set_video_timestamp] = useState("")
    const [video_timestamp_date, set_video_timestamp_date] = useState("")

    useEffect(() => {
        if (mRespActionList !== null && respActionList !== mRespActionList) {
            // console.log(mRespActionList)
            setRespActionList(mRespActionList)
        }
    }, [mRespActionList])

    useEffect(() => {
        if (respActionList !== null) {
            set_pitch_type(respActionList.getPitchType())
            set_pitch_speed(respActionList.getPitchSpeed())
            set_video_timestamp(moment(respActionList.video_timestamp).format('HH:mm:ss'))
            set_video_timestamp_date(moment(respActionList.video_timestamp).format('YYYY/MM/DD'))
        }
    }, [respActionList])

    function close() {
        set_Close(mRespActionList.record_id, false)
    }

    function save() {
        if (setIsLoading !== undefined)
            setIsLoading(true)
        var mRespActionEditPitch = new RespActionEditPitch({
            record_id: respActionList.record_id,
            type: pitch_type,
            speedKM: pitch_speed,
            video_timestamp: moment(video_timestamp_date + " " +video_timestamp, 'YYYY/MM/DD hh:mm:ss').valueOf()
        })
        api_setPlateRecordActionDetailPitch({
            mRespActionEditPitch,
            success: (obj) => {
                setIsLoading(false)
                respActionList.pitch_type = pitch_type
                respActionList.pitch_speed = pitch_speed
                respActionList.video_timestamp = mRespActionEditPitch.video_timestamp
                set_Save(respActionList.record_id, respActionList)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }


    return <>
        <div className="row">
            <div className="col-sm-12">
                <SingleSelect title={"球種"}
                    val={pitch_type}
                    attr={pitch_type_arr}
                    action={set_pitch_type}
                    hasBlank={true}
                    size={3}
                />
                <SingleInput title={"球速"} val={pitch_speed} action={set_pitch_speed} size={3} />
                <SingleInput title={"轉播影片時間"} val={video_timestamp} action={set_video_timestamp} size={3} />
                {/* <SingleText title={"轉播影片時間"} val={video_timestamp} size={1} />
            <SingleText title={"進壘座標"} val={respActionList.getClipId()} size={1} /> */}
            </div>
        </div>
        <Space />
        <div className="row">
            <div className="col-sm-12">
                <SingleText title={"ClipID"} val={respActionList.get_ClipId()} size={2} />
                <SingleText title={"球速"} val={respActionList.get_VeloRel()} size={2} />
                <SingleText title={"小懷主機時間"} val={respActionList.get_PitchTime()} size={3} />
                <SingleText title={"進壘座標"} val={respActionList.get_KZone()} size={3} />
            </div>
        </div>
        <Space />
        <div className="row">
            <div className="col-sm-12">
                <SingleText title={"轉軸"} val={respActionList.get_SpinClock()} size={2} />
                <SingleText title={"轉速"} val={respActionList.get_SpinRate()} size={2} />
                <SingleText title={"有效轉速"} val={respActionList.get_TrueSpin()} size={2} />
                <SingleText title={"GYRO轉軸"} val={respActionList.get_Gyro()} size={2} />
                <SingleText title={"旋轉效率"} val={respActionList.get_SpinEFF()} size={2} />
            </div>
        </div>
        <div className="hr-line-dashed"></div>
        <div className="row m-t-sm m-t-sm">
            <div className="col-sm-4 col-sm-offset-5">
                <CancelButton name={"關閉"} action={close} />
                <SubmitButton name={"修改"} action={save} />
            </div>
        </div>
    </>
}